import { Incentive } from "@/pages/incentive";
import { IncentiveManagerPage } from "@/pages/incentive/manager";
import { MILL_2 } from "../mill-config/mill-config";
import { PermissionRoute } from "./PermissionRoute";

export const routeIncentive = "/incentive";
export const routeIncentiveManager = "/incentive/manager";
const incentiveDashboardPermission = "ui.navbar.mill.incentive.dashboard";
const incentiveManagerPermission = "ui.navbar.mill.incentive.manager";

export const incentiveRoutes = [
	{
		path: routeIncentive,
		element: (
			<PermissionRoute permission={incentiveDashboardPermission}>
				<Incentive assetId={MILL_2.id} />
			</PermissionRoute>
		),
		permission: incentiveDashboardPermission,
	},
	{
		path: routeIncentiveManager,
		element: (
			<PermissionRoute permission={incentiveManagerPermission}>
				<IncentiveManagerPage assetId={MILL_2.id} />
			</PermissionRoute>
		),
		permission: incentiveManagerPermission,
	},
];
